import { useMemo } from 'react';
import { EditorStats } from '../types/editor';

export const useWordCount = (content: string): EditorStats => {
  return useMemo(() => {
    const trimmedContent = content.trim();
    
    const words = trimmedContent === '' ? 0 : trimmedContent.split(/\s+/).length;
    const characters = content.replace(/\s/g, '').length;
    const charactersWithSpaces = content.length;
    const lines = content.split('\n').length;
    const wordsPerMinute = 200;
    const readingTime = Math.ceil(words / wordsPerMinute);

    return {
      words,
      characters,
      charactersWithSpaces,
      lines,
      readingTime,
    };
  }, [content]);
};